import { createApp } from 'vue'
import { createHead } from '@unhead/vue'
import App from './App.vue'
import router from './router'
import { i18n, initI18n } from './locales'
import './assets/main.css'

const app = createApp(App)
const head = createHead()

app.use(router)
app.use(head)
app.use(i18n)

initI18n().then(() => {
  app.mount('#app')
})
